import PropTypes from 'prop-types';
import React, { Component } from 'react';

class AutoText extends Component {


    state = {

    };

    render() {

        const { task, selected_task, toggleSidebar  } = this.props;
        const title = task.template_text ? task.template_text.name : <span className="text-danger"><i className="fas fa-exclamation-triangle mr-2" /> Text Template Not Set</span>

        return (

            <div className={selected_task === task._id ? "selected auto" : "auto"} >
                <div className="wrapper" onClick={() => toggleSidebar(true, task._id)}>
                    <div className="title">
                        <b><i className="fas fa-phone mr-3 text-info-original" />Send Text: </b>
                        {title}
                    </div>
                </div>
            </div>

        )

    }

}

AutoText.propTypes = {
    task            : PropTypes.object.isRequired,
    toggleSidebar   : PropTypes.func.isRequired,
    selected_task   : PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default AutoText;
